import {Component, OnInit} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import {ActivatedRoute} from "@angular/router";
import {ProfileService} from "../profile.service";
import {Profile} from "../profile";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {MatGridListModule} from "@angular/material/grid-list";
import {
  MatCardModule,
} from "@angular/material/card";
import {ButtonContactEnquireComponent} from "../button-contact-enquire/button-contact-enquire.component";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from '@angular/material/icon';
import {ButtonSharedComponent} from "../components/buttons/button-shared/button-shared.component";
import {SeoService} from "../seo-service.service";

@Component({
  selector: 'app-our-team-detail',
  imports: [CommonModule, MatGridListModule, MatCardModule, ButtonContactEnquireComponent, MatButtonModule, ButtonSharedComponent, MatIconModule, NgOptimizedImage],
  templateUrl: './our-team-detail.component.html',
  standalone: true,
  styleUrl: './our-team-detail.component.scss'
})

export class OurTeamDetailComponent implements OnInit {
  profile?: Profile;

  constructor(
    private route: ActivatedRoute,
    private profileService: ProfileService,
    private seo: SeoService
  ) {}

  ngOnInit(): void{

    // Get the ID from the route parameters
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (id) {
      this.profileService.getProfileById(id).subscribe((profile) => {
        if (profile) {
          this.profile = profile;
          const pronouns = this.profileService.getPronouns(this.profile.pronoun);
          // for crawlers
          this.seo.updateMeta(
            `${this.profile?.title} ${this.profile?.firstname} ${this.profile?.lastname} | Sydney Advanced Endocrinology`,
            `${this.profile?.title} ${this.profile?.firstname} ${this.profile?.lastname} is an ${this.profile?.role} at Sydney Advanced Endocrinology. Discover ${pronouns.possessive} qualifications, expertise, and contributions to patient care.`,
              `/our-team-detail/${id}`
          );
        } else {
          console.error(`Profile with ID ${id} not found`);
        }
      });
    }
  }
}
